import { EventEmitter, Injectable } from '@angular/core';
import { FormControlName } from './contact-form-types';
import { ContactFormService } from './contact-form.service';

@Injectable({
  providedIn: 'root',
})
export class ContactFormFocusInteractorService {
  focus: EventEmitter<FormControlName>;

  constructor(private contactFormService: ContactFormService) {
    this.focus = new EventEmitter();
  }

  /**
   * TABALHANDO AQUI NA QUESTÃO DO FOCO ATRAVÉS DO TECLADO, IMPORTANTE!
   */
  nextElementFromTabEvent(controlName: FormControlName) {
    setTimeout(() => {
      // if (controlName === FormControlName.PadraoEntrada) {
      //   this.focus.emit(FormControlName.MediaConsumo);
      // } else
      if (controlName === FormControlName.Estado) {
        this.focus.emit(FormControlName.Cidade);
      }
    }, 0);
  }
}
